import React from 'react';
import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';
import {formatDate} from '@frontend/shared';

import './DeliveryDate.scss';

const b = block('delivery-date');

export interface DeliveryDateProps {
    value: Date;
    className?: string;
    maxValue?: Date;
}

export const DeliveryDate: React.FC<DeliveryDateProps> = (props) => {
    const formattedDate = formatDate(props.value, 'DD.MM.YY');
    const formattedMaxDate = props.maxValue ? formatDate(props.maxValue, 'DD.MM.YY') : null;

    return (
        <div className={b(null, props.className)}>
            <Text variant='body-1'>{formattedDate}</Text>
            {props.maxValue && (
                <Text variant='body-1' color='secondary'>
                    {formattedMaxDate}
                </Text>
            )}
        </div>
    );
};
